import { FC, ReactElement, useState } from 'react'

import { ProductWithVariants } from '../../../types'
import ProductDescriptionCard from './productDescriptionCard'
import ProductMainCard from './productMainCard'
import './index.css'

const ProductCard: FC<{ product: ProductWithVariants }> = ({ product }): ReactElement => {
  const [isHovering, setIsHovering] = useState(false)
  return (
    <div
      className="product-card__container product-card--general"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onFocus={() => setIsHovering(true)}
      onBlur={() => setIsHovering(false)}
    >
      <ProductMainCard product={product} />
      <div className={`product-card__overlay ${isHovering ? 'product-card--show' : 'product-card--hidden'}`}>
        <ProductDescriptionCard product={product} />
      </div>
    </div>
  )
}

export default ProductCard
